export default __webpack_public_path__ + "static/media/notFound.fc43eef8.png";